import { Locale } from 'chaika-enums';
export const pricesPage = {
    currencyMastMach: {
        [Locale.Ru]: 'Валюты цены и всех юридических лиц должна совпадать',
        [Locale.Am]: 'Գնի և բոլոր իրավաբանական անձանց արժույթները պետք է համընկնեն',
        [Locale.En]: 'The currency of the price and all legal entities must match',
        [Locale.Pt]: 'A moeda do preço e todas as pessoas jurídicas devem corresponder',
        [Locale.Ge]: 'The currency of the price and all legal entities must match',
    },
    mustHaveZeroPrice: {
        [Locale.Ru]: 'Составная услуга должна иметь нулевую цену',
        [Locale.Am]: 'Բաղադրյալ ծառայությունը պետք է ունենա զրոյական գին',
        [Locale.En]: 'A composite service must have a zero price',
        [Locale.Pt]: 'Um serviço composto deve ter preço zero',
        [Locale.Ge]: 'A composite service must have a zero price',
    },
    alreadyHasBasePrice: {
        [Locale.Ru]: 'Для юридических лиц уже есть базовая цена',
        [Locale.Am]: 'Իրավաբանական անձանց համար արդեն կա բազային գին',
        [Locale.En]: 'There is already a base price for legal entities',
        [Locale.Pt]: 'Já existe preço base para pessoas jurídicas',
        [Locale.Ge]: 'There is already a base price for legal entities',
    },
    needBasePriceFirst: {
        [Locale.Ru]: 'Сначала должна быть создана базовая цена',
        [Locale.Am]: 'Նախ պետք է ստեղծվի բազային գին',
        [Locale.En]: 'First a base price must be created',
        [Locale.Pt]: 'Primeiro, um preço base deve ser criado',
        [Locale.Ge]: 'First a base price must be created',
    },
    compositeServiceCanBeBase: {
        [Locale.Ru]: 'Составная услуга может быть только базовой',
        [Locale.Am]: 'Բաղադրյալ ծառայությունը կարող է լինել միայն բազային',
        [Locale.En]: 'A composite service can only be a basic one',
        [Locale.Pt]: 'Um serviço composto só pode ser básico',
        [Locale.Ge]: 'A composite service can only be a basic one',
    },
    changePriceAirtable: {
        [Locale.Ru]: `Изменить цену в Airtable`,
        [Locale.Am]: `Փոփոխել գինը Airtable-ում`,
        [Locale.En]: `Change Price in Airtable`,
        [Locale.Pt]: 'Alterar preço no Airtable',
        [Locale.Ge]: `Change Price in Airtable`,
    },
    changePrice: {
        [Locale.Ru]: `Изменить цену`,
        [Locale.Am]: `Փոփոխել գինը`,
        [Locale.En]: `Change Price`,
        [Locale.Pt]: 'Alterar preço',
        [Locale.Ge]: `Change Price`,
    },
    printPriceList: {
        [Locale.Ru]: `Печать прайс листа`,
        [Locale.Am]: `Գնացուցակի տպում`,
        [Locale.En]: `Print price list`,
        [Locale.Pt]: 'Imprimir lista de preços',
        [Locale.Ge]: `Print price list`,
    },
    printPersonPriceList: {
        [Locale.Ru]: `Печать индивидуального прайс листа`,
        [Locale.Am]: `Անհատական գնացուցակի տպում`,
        [Locale.En]: `Printing of individual price list`,
        [Locale.Pt]: 'Impressão de lista de preços individual',
        [Locale.Ge]: `Printing of individual price list`,
    },
    errorOnPriceCreation: {
        [Locale.Ru]: `Ошибка при создании цены`,
        [Locale.Am]: `Գին ստեղծելիս սխալ`,
        [Locale.En]: `Error creating price`,
        [Locale.Pt]: 'Erro ao criar preço',
        [Locale.Ge]: `Error creating price`,
    },
    errorOnPriceUpdate: {
        [Locale.Ru]: 'Ошибка при обновлении цены',
        [Locale.Am]: 'Գինը թարմացնելիս սխալ',
        [Locale.En]: 'Error updating price',
        [Locale.Pt]: 'Erro ao atualizar o preço',
        [Locale.Ge]: 'Error updating price',
    },
    addCompositeService: {
        [Locale.Ru]: `Добавить составную услугу`,
        [Locale.Am]: `Ավելացնել բաղադրյալ ծառայություն`,
        [Locale.En]: `Add a composite service`,
        [Locale.Pt]: 'Adicione um serviço composto',
        [Locale.Ge]: `Add a composite service`,
    },
    hasIndPriceText: {
        [Locale.Ru]: `Для данной услуги добавлены индивидуальные цены.
При архивации базовой цены все индивидуальные цены также уйдут в архив. Продолжить?`,
        [Locale.Am]: `Այս ծառայության համար ավելացված են անհատական գներ։
Բազային գինը արխիվացնելիս բոլոր անհատական գները ևս կտեղափոխվեն արխիվ։ Շարունակե՞լ`,
        [Locale.En]: `Individual prices have been added for this service.
When archiving the base price, all individual prices will also be archived. Continue?`,
        [Locale.Pt]: `Foram adicionados preços individuais para este serviço.
Ao apresentar o preço base, todos os preços individuais serão também apresentados. Continuar?`,
        [Locale.Ge]: `Individual prices have been added for this service.
When archiving the base price, all individual prices will also be archived. Continue?`,
    },
    idSeparateByColonsText: {
        [Locale.Ru]: `айдишники юридических лиц, разделенные двоеточием`,
        [Locale.Am]: `իրավաբանական անձանց ID-ները՝ բաժանված երկու կետով`,
        [Locale.En]: `IDs of legal entities, separated by colons`,
        [Locale.Pt]: 'IDs de pessoas jurídicas, separados por dois pontos',
        [Locale.Ge]: `IDs of legal entities, separated by colons`,
    },
    priceLoadedByCSV: {
        [Locale.Ru]: `Цены успешно загружены из CSV файла`,
        [Locale.Am]: `Գները հաջողությամբ բեռնվել են CSV ֆայլից`,
        [Locale.En]: `Prices successfully downloaded from CSV file`,
        [Locale.Pt]: 'Preços baixados com sucesso do arquivo CSV',
        [Locale.Ge]: `Prices successfully downloaded from CSV file`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
